













































































import { defineComponent, reactive, SetupContext, toRef, toRefs, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";

interface School {
  id?: number;
  name: string;
  address: string;
  contact_address: string;
  counter_responsible: string;
  counter_mail_address: string;
  ip_address: string;
}

interface SchoolEditData {
  currentUser: any;
  school: School;
  errors: string[];
  school_id?: number;
  isCreate: boolean;
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<SchoolEditData>({
      currentUser: context.root.$store.state.currentUser,
      school: {
        id: null,
        name: "",
        address: "",
        contact_address: "",
        counter_responsible: "",
        counter_mail_address: "",
        ip_address: "",
      },
      errors: [],
      school_id: context.root.$route.query.id ? parseInt(context.root.$route.query.id.toString()) : null,
      isCreate: context.root.$route.query.id ? false : true,
    });


    /******************************
     * methods
     ******************************/
    
    /**
     * 戻る処理
     */
    const goBack = (): void => {
        context.root.$router.go(-1);
    };

    /**
     * 学校登録処理
     */
    const createSchool = async (): Promise<void> => {

      if (!validate() || !confirm(`学校情報を登録します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/school_edit`, {school: state.school}).then(response => {
        alert(`登録処理が完了しました。`);
        goBack();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    const updateSchool = async ():Promise<void> => {

      if (!validate() || !confirm(`学校情報を更新します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.patch(`/api/school_edit/${state.school_id}`, {school: state.school}).then(response => {
        alert(`更新処理が完了しました。`);
        goBack();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    } 

    /**
     * 入力チェック処理
     */
    const validate = (): boolean => {

      state.errors = [];

      if (!state.school.name) {
        state.errors.push("学校名は必須です。");
      }

      if (state.school.ip_address) {

        const regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        const ipAddresses = state.school.ip_address.split(",");

        const formatErrorIpAddress = ipAddresses.filter(x => !regex.test(x));

        if (formatErrorIpAddress.length > 0) {
          state.errors.push("IPアドレスのフォーマットが違います。");
        }
      }

      return state.errors.length == 0;
    }

    const targetUpdateSchool = async (): Promise<void> => {

      if (state.isCreate) {
        return;
      }

      context.root.$store.dispatch("showOverlay", `データ取得中... しばらくお待ちください。`);

      state.errors = [];
  
      await http.get(`/api/school_edit/${state.school_id}/edit`).then(response => {

        // 検索結果設定
        state.school = response.data.school;
      })
      .catch(error => {

        if(error.response.status == 422){
          alert(`編集対象学校情報の取得処理に失敗しました。学校一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`編集対象学校情報の取得処理に失敗しました。学校一覧に戻ります。`);
        }

        goBack();
      });

      context.root.$store.dispatch("hideOverlay");
    }


    /******************************
     * created
     ******************************/

    targetUpdateSchool();


    /******************************
     * watch
     ******************************/


    return {
      ...toRefs(state),
      goBack,
      createSchool,
      updateSchool,
    };
  },
})
